jQuery(function($) {
    $(document).ready(function() {

        //NAVIFIX
        window.addEventListener('click', function(e){
            if (document.getElementById('navbarNavOffcanvas').contains(e.target)) {
                $('.navbar-toggler').addClass('activee'); 
            } 
            else if (document.getElementById('heremeout').contains(e.target))  {
                $('.navbar-toggler').toggleClass('activee'); 
            }
            else {
                $('.navbar-toggler').removeClass('activee'); 
            }
        });

        //lightbox
        const options = {
            keyboard: true,
            size: 'xl',
        };

        document.querySelectorAll('.lightbox-toggle').forEach((el) => el.addEventListener('click', (e) => {
            e.preventDefault();
            const lightbox = new Lightbox(el, options);
            lightbox.show();
        }));

        $('.carousel-item:first').addClass('active');
        $('.carousel-indicators button:first').addClass('active');

        $("#ii").on("click", function() { 
            $('#accordionpm').addClass('hidden');
            $('#accordionii').removeClass("hidden");
            $('#pm').removeClass("active");
            $('#toimipisteet').removeClass("active");
            $(this).addClass("active");
        });

        const imagesArray = document.querySelectorAll('.carousel-item');
        const leftArrow = document.querySelector('.carousel-control-prev')
        const rightArrow = document.querySelector('.carousel-control-next')
        const isHidden = "hidden";

        if(imagesArray.length === 1){
            rightArrow.classList.add(isHidden);
            leftArrow.classList.add(isHidden);
        }

    });
});